import { Cushion, FlexContainer, Grid, Shimmer, Show, Space } from '@pitchero/react-ui';
import React from 'react';

const LoadingState = () => (
  <Grid
    columns="1fr"
    columnGap="medium"
    responsive={[
      {
        minWidth: 'fullHeader',
        props: { columns: 'minmax(auto, 970px) minmax(auto, 400px)' },
      },
    ]}
  >
    <Cushion vertical="small" horizontal="medium" component="div">
      <Shimmer width="100%" height="60px" radius="10px" />
      <Space vertical="small">
        <FlexContainer flexDirection="column" style={{ gap: '10px' }}>
          <Shimmer width="100%" height="150px" radius="10px" />
          <Shimmer width="100%" height="150px" radius="10px" />
          <Shimmer width="100%" height="150px" radius="10px" />
        </FlexContainer>
      </Space>
    </Cushion>
    <Show minWidth="fullHeader" component="div">
      <Cushion vertical="small" horizontal="medium" component="div">
        <Shimmer width="100%" height="60px" radius="10px" />
        <Space vertical="small">
          <Shimmer width="100%" height="300px" radius="10px" />
        </Space>
      </Cushion>
    </Show>
  </Grid>
);

export default LoadingState;
